import { SyntheticEvent, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { TextAlignmentContainer } from '../../../../../TextAlignmentContainer/TextAlignmentContainer';
import { Text } from '../../../../../atoms/Text/Text';
import { commonMessages } from '../../../../../atoms/CommonMessages/messages';
import { H1 } from '../../../../../atoms/Heading/Heading';
import { ScopeItem } from '../../../../../../lib-api/services/Oauth';
import { useAppSelector } from '../../../../../../stores/redux-store';
import { ScopesDetailOverlay } from '../../../LegalDisclaimer/LegalDisclaimerAuth/molecules/ScopesDetailOverlay/ScopesDetailOverlay';
import { UnderlinedTextButton } from '../../../../../atoms/Button/TextButton';
import { messages as legalMessages } from '../../../LegalDisclaimer/LegalDisclaimerAuth/messages';

type LoginTitleScopeModalProps = {
  passwordHelpText: string;
};

export const LoginTitleScopeModal = ({ passwordHelpText }: LoginTitleScopeModalProps) => {
  const [isScopesDetailOverlayOpen, setScopesOverlayOpen] = useState(false);
  const scopesButtonRef = useRef<HTMLAnchorElement>(null);

  const scopesDescriptionsList: ScopeItem[] = useAppSelector(
    (state) => Object.values(state.oauth.description?.scopesDescriptionsList ?? {}) ?? []
  );

  const openScopesModal = (event: SyntheticEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setScopesOverlayOpen(true);
  };

  const closeScopesModal = () => {
    setScopesOverlayOpen(false);

    if (scopesButtonRef.current) {
      scopesButtonRef.current.focus();
    }
  };

  return (
    <Box mb="medium">
      <TextAlignmentContainer>
        <H1>
          <FormattedMessage {...commonMessages.logIn} />
        </H1>
        <Text color="secondary" mt="xxsmall">
          {passwordHelpText}{' '}
          <UnderlinedTextButton
            onClick={openScopesModal}
            as="a"
            role="button"
            tabIndex={0}
            href=""
            ref={scopesButtonRef}
          >
            <FormattedMessage {...legalMessages.readMore} />
          </UnderlinedTextButton>
        </Text>
        {isScopesDetailOverlayOpen && (
          <ScopesDetailOverlay close={closeScopesModal} scopes={scopesDescriptionsList} />
        )}
      </TextAlignmentContainer>
    </Box>
  );
};
